import { useEffect } from 'react';

// Extend the Window interface to include fbq
declare global {
  interface Window {
    fbq: (action: string, event: string, data?: any) => void;
  }
}

interface FacebookPixelProps {
  pixelId: string;
}

const FacebookPixel: React.FC<FacebookPixelProps> = ({ pixelId }) => {
  useEffect(() => {
    // Check if fbq is available (loaded from the script in index.html)
    if (typeof window !== 'undefined' && window.fbq) {
      // Initialize the pixel if not already done
      window.fbq('init', pixelId);
      window.fbq('track', 'PageView');
    }
  }, [pixelId]);

  return null; // This component doesn't render anything
};

// Utility functions for tracking custom events
export const trackFacebookEvent = (eventName: string, data?: any) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, data);
  }
};

// Common Facebook pixel events
export const FacebookEvents = {
  // Standard events
  PAGE_VIEW: 'PageView',
  PURCHASE: 'Purchase',
  ADD_TO_CART: 'AddToCart',
  INITIATE_CHECKOUT: 'InitiateCheckout',
  LEAD: 'Lead',
  COMPLETE_REGISTRATION: 'CompleteRegistration',
  SEARCH: 'Search',
  VIEW_CONTENT: 'ViewContent',
  ADD_TO_WISHLIST: 'AddToWishlist',
  ADD_PAYMENT_INFO: 'AddPaymentInfo',

  // Custom events (you can add your own)
  SIGNUP: 'SignUp',
  LOGIN: 'Login',
  SUBSCRIPTION: 'Subscription',
  TRIAL_START: 'TrialStart',
  TRIAL_END: 'TrialEnd',
} as const;

export default FacebookPixel;
